import { Model } from "pinia-orm";
import { COMPANY_TYPE_CHOICES } from "@/constants/companyType";

export default class AdditionalMaterial extends Model {
  static entity = "additionalMaterials";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      name: this.attr(null),
      company: this.attr(null),
      companyType: this.attr(COMPANY_TYPE_CHOICES.SUBCONTRACTOR.value),
      materialType: this.attr(null),
      isValidated: this.boolean(false),
      preparation: this.attr(null),
    };
  }

  get designation() {
    return this.name;
  }

  get typologies() {
    return [];
  }
}
